// todo import request helpers when setting

const actions = {

    POST_REGISTRATION_FORM: 'POST_REGISTRATION_FORM',
};


function postRegistrationForm ( registration ) {
    return ( dispatch ) => {
        dispatch({
            type: actions.POST_REGISTRATION_FORM,
            registration: registration,
        })
    }
}

module.exports = {
    actions,
    postRegistrationForm,
};


// WEBPACK FOOTER //
// src/client/actions/registration/registration.js